var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    className: "sc-4d50cb22-0 hvjzRu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.572 25.31 11.073-3.682V9.135l-11.073 3.684V25.31Z",
    fill: "#D97924"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.572 25.31 1.5 21.629V9.135l11.072 3.684V25.31Z",
    fill: "#FBB040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.135 12.572 5.5l11.074 3.635-11.074 3.684L1.5 9.135Z",
    fill: "#FFDD7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.56 10.494 8.518 6.832 5.6 7.789l11.061 3.67v3.266l2.898-.964v-3.267Z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.662 11.458 2.898-.964v3.267l-2.898.964v-3.267Z",
    fill: "#E4E1DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.906 20.463a7.304 7.304 0 0 0 7.297 7.297 7.304 7.304 0 0 0 7.297-7.297 7.304 7.304 0 0 0-7.297-7.297 7.304 7.304 0 0 0-7.297 7.297Z",
    fill: "#2572F7",
    stroke: "#FFFFFF",
    strokeWidth: "2px"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.754 23.754a.757.757 0 0 1-.536-.223l-1.662-1.662a.76.76 0 0 1 1.074-1.074l1.124 1.125 3.986-3.987a.76.76 0 0 1 1.074 1.074l-4.523 4.523a.758.758 0 0 1-.537.224Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.116a1e0f7df52f1888894bd28772d92d.svg";
export { ForwardRef as ReactComponent };